import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { Cred } from 'src/app/shared/cred';
import { SharedService } from 'src/app/shared/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ShopService } from 'src/app/modules/user/shops/service/shop.service';
import { Subscription } from 'rxjs';
import companies from '../../../assets/companies.json';

@Component({
  selector: 'shopifylogin',
  templateUrl: './shopifylogin.template.html',
  styleUrls: ['./shopifylogin.style.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [AuthService, Cred, SharedService, ShopService],
  host: {
    class: 'login-page app'
  }
})
export class shopifylogin implements OnInit, OnDestroy {
  shopifyshopcreated: any = false;
  currentUser: String;
  currentShop: String;
  currentToken: String;
  sub: Subscription;
  authenticationError: boolean;
  isLoggedin: boolean = false;
  error: string;
  cred: Cred;
  currentCompany: any;
  currentLanguage: string = 'en';

  // Define available languages with display names (matching your translation files)
  availableLanguages = [
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
    { code: 'de', name: 'Deutsch' },
    { code: 'cn', name: '中文' },
    { code: 'ar', name: 'العربية' }
  ];

  constructor(
    public translate: TranslateService,
    private _service: AuthService,
    private _router: Router,
    private sharedService: SharedService,
    private activeRoute: ActivatedRoute,
    private shopService: ShopService
  ) {
    // Initialize cred object
    this.cred = new Cred();
    
    console.log("App Lang-" + translate.getDefaultLang());
    
    // Set up translation languages - matching your actual translation files
    translate.addLangs(['en', 'fr', 'de', 'cn', 'ar']);
    translate.setDefaultLang('en');
    
    // Get browser language or use stored language preference
    const browserLang = translate.getBrowserLang();
    const storedLang = localStorage.getItem('selectedLanguage');
    const preferredLang = storedLang || (browserLang && ['en', 'fr', 'de', 'cn', 'ar'].includes(browserLang) ? browserLang : 'en');
    
    this.currentLanguage = preferredLang;
    translate.use(preferredLang);
  }

  login() {
    this.error = ''; // Clear previous errors
    
    this._service.login(this.cred.username, this.cred.password).subscribe(
      data => {
        this._router.navigate(['']);
        this.isLoggedin = true;
        this._service.logSessionActivity("Login", this.cred.username).subscribe(data => {
          this._router.navigate(['/app']);
        });
      },
      (err) => {
        this.isLoggedin = false;
        this.error = 'Username and/or password are invalid !';
      },
      () => {
        this.currentUser = this.cred.username;
        this.shopService
          .createShopShopifyNonConnected(
            this.currentShop,
            this.currentUser,
            this.currentToken
          )
          .subscribe(
            data => {
              this.shopifyshopcreated = data;
              console.log('shop creation is =' + this.shopifyshopcreated);
            },
            err => {
              return console.log(`THE SHOP WASNT CREATED : ${err} `);
            }
          );
      }
    );
  }

  logout() {
    this._service.logout().subscribe();
  }

  // Method to get display name for language code
  getLanguageDisplayName(langCode: string): string {
    const language = this.availableLanguages.find(lang => lang.code === langCode);
    return language ? language.name : langCode;
  }

  changeLanguage(lang: string) {
    if (lang && ['en', 'fr', 'de', 'cn', 'ar'].includes(lang)) {
      this.currentLanguage = lang;
      this.translate.use(lang);
      
      // Store language preference
      localStorage.setItem('selectedLanguage', lang);
      
      // Update shared service
      this.sharedService.setLanguage(lang);
      
      console.log("Language changed to:", lang);
    }
  }

  // Get available languages for the dropdown
  getAvailableLanguages() {
    return this.availableLanguages;
  }

  ngOnInit() {
    this.currentCompany = companies.find((company) => company.active);
    
    // Subscribe to route parameters
    this.sub = this.activeRoute.params.subscribe(params => {
      this.currentShop = params['shop'];
      this.currentToken = params['token'];
      console.log('Current Shop:', this.currentShop);
      console.log('Current Token:', this.currentToken);
    });

    // Initialize language from stored preference or browser
    const storedLang = localStorage.getItem('selectedLanguage');
    if (storedLang && ['en', 'fr', 'de', 'cn', 'ar'].includes(storedLang)) {
      this.currentLanguage = storedLang;
      this.translate.use(storedLang);
    }
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}